import NewsFilter from "@root/modules/NewsPage/NewsFilter";
if (document.querySelector('[data-news-page]')) {
    new NewsFilter();
    var newsCtas = document.querySelectorAll('[data-news-cta-form]');
    newsCtas.forEach(function (newsCta) {
        newsCtaForm(newsCta);
    });
}
function newsCtaForm(element) {
    var newsletterInputContainer = element.querySelector('.gfield--type-email');
    var newsletterLabel = newsletterInputContainer.querySelector('label');
    var newsletterInput = newsletterInputContainer.querySelector('input:not([type="file"])');
    newsletterInput.addEventListener('input', function (event) {
        var currentInput = event.currentTarget;
        if (currentInput.value.trim() === '') {
            newsletterLabel.classList.remove('active');
        }
        else {
            newsletterLabel.classList.add('active');
        }
    });
}
